module.exports = __webpack_public_path__ + "assets/img/AquavistaGlass-Website.895b346e.webp";